export const FavoriteType = {
	author: 'author',
	series: 'series',
};
